<template>
  <header class="bg-white shadow-sm sticky top-0 z-50">
    <div class="container mx-auto px-4 max-w-7xl">
      <div class="flex items-center justify-between h-16">
        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img 
            src="/logo-e2m.png" 
            alt="E2M Logo" 
            class="h-10 w-auto"
          />
        </router-link>

        <!-- Navigation -->
        <nav class="hidden md:flex items-center gap-8">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="text-muted hover:text-ink transition-colors font-medium"
            active-class="text-brand"
          >
            {{ $t(item.label) }}
          </router-link>
        </nav>

        <!-- Actions -->
        <div class="flex items-center gap-4">
          <BaseButton
            variant="primary"
            size="sm"
            @click="$router.push('/demo')"
          >
            {{ $t('common.requestDemo') }}
          </BaseButton>
          
          <!-- Mobile menu button -->
          <button
            @click="isMobileMenuOpen = !isMobileMenuOpen"
            class="md:hidden p-2 text-muted hover:text-ink"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile menu -->
      <div v-if="isMobileMenuOpen" class="md:hidden py-4 border-t">
        <nav class="flex flex-col gap-4">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="text-muted hover:text-ink transition-colors font-medium"
            active-class="text-brand"
            @click="isMobileMenuOpen = false"
          >
            {{ $t(item.label) }}
          </router-link>
        </nav>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BaseButton from './BaseButton.vue'
import { navItems } from '@/data/nav'

const isMobileMenuOpen = ref(false)
</script>